import ElementalArea from "@/components/global/ElementalArea";
import { Hero } from "@/components/global/Hero";
import Layout from "@/components/layouts/Main";
import { PageType } from "@/types";

const Page = ({ page }: { page: PageType }) => (
    <Layout page={page}>
        {/* {!page.HideHero && <Hero page={page} />} */}
        <ElementalArea ElementalArea={page.ElementalArea} />
    </Layout>
);

export default Page;
